import gettext from '@sdk/lang/gettext';

import AutoAssignSvg from '@web/assets/svg/Icons/32/auto-assign-gray.svg';
import ReportsSvg from '@web/assets/svg/Icons/32/reports-gray.svg';
import PtoSvg from '@web/assets/svg/Icons/32/timeoff-gray.svg';
import TimeSvg from '@web/assets/svg/Icons/32/time-gray.svg';
import NoShowSvg from '@web/assets/svg/Icons/32/no-show-gray.svg';
import LateArrivalSvg from '@web/assets/svg/Icons/32/late-arrival-gray.svg';
import ShiftSvg from '@web/assets/svg/Icons/32/shift-gray.svg';
import TaskSvg from '@web/assets/svg/Icons/32/task-gray.svg';
import LaborCostSvg from '@web/assets/svg/Icons/32/labor-gray.svg';
import UnavailabilitySvg from '@web/assets/svg/Icons/32/unavailability-gray.svg';
import MessagesSvg from '@web/assets/svg/Icons/32/message-gray.svg';
import ShiftSwapSvg from '@web/assets/svg/Icons/32/shift-swap-gray.svg';
import TimesheetSvg from '@web/assets/svg/Icons/32/timesheet-gray.svg';
import CalendarSyncSvg from '@web/assets/svg/Icons/32/calendarsync-gray.svg';

export const downgradeFeaturesToLose = [
  {
    name: 'auto-assigning',
    description: gettext('Auto-assigning'),
    icon: <AutoAssignSvg />,
  },
  {
    name: 'reports',
    description: gettext('Reports'),
    icon: <ReportsSvg />,
  },
  {
    name: 'pto',
    description: gettext('PTO management'),
    icon: <PtoSvg />,
  },
  {
    name: 'kiosk',
    description: gettext('Kiosk time tracking'),
    icon: <TimeSvg />,
  },
  {
    name: 'no-show',
    description: gettext('No-shows and sick call-outs'),
    icon: <NoShowSvg />,
  },
  {
    name: 'late-arrival',
    description: gettext('Late arrivals'),
    icon: <LateArrivalSvg />,
  },
  {
    name: 'shift-acceptance',
    description: gettext('Shift acceptance'),
    icon: <ShiftSvg />,
  },
  {
    name: 'tasks',
    description: gettext('Task management'),
    icon: <TaskSvg />,
  },
];

export const cancelFeaturesToLoseFromBusiness = [
  {
    name: 'auto-assigning',
    description: gettext('Auto-assigning'),
    icon: <AutoAssignSvg />,
  },
  {
    name: 'reports',
    description: gettext('Reports'),
    icon: <ReportsSvg />,
  },
  {
    name: 'pto',
    description: gettext('PTO management'),
    icon: <PtoSvg />,
  },
  {
    name: 'timeclock',
    description: gettext('Time tracking'),
    icon: <TimeSvg />,
  },
  {
    name: 'no-show',
    description: gettext('No-shows and sick call-outs'),
    icon: <NoShowSvg />,
  },
  {
    name: 'labor-cost',
    description: gettext('Labor cost management'),
    icon: <LaborCostSvg />,
  },
  {
    name: 'unavailability',
    description: gettext('Unavailability'),
    icon: <UnavailabilitySvg />,
  },
  {
    name: 'tasks',
    description: gettext('Task management'),
    icon: <TaskSvg />,
  },
  {
    name: 'shift-swaps',
    description: gettext('Shift swaps'),
    icon: <ShiftSwapSvg />,
  },
  {
    name: 'messages',
    description: gettext('Private and group messaging'),
    icon: <MessagesSvg />,
  },
];

export const cancelFeaturesToLoseFromPremium = [
  {
    name: 'timeclock',
    description: gettext('Time tracking'),
    icon: <TimeSvg />,
  },
  {
    name: 'labor-cost',
    description: gettext('Labor cost management'),
    icon: <LaborCostSvg />,
  },
  {
    name: 'shift-swaps',
    description: gettext('Shift swaps'),
    icon: <ShiftSwapSvg />,
  },
  {
    name: 'messages',
    description: gettext('Private and group messaging'),
    icon: <MessagesSvg />,
  },
  {
    name: 'overtime',
    description: gettext('Overtime tracking'),
    icon: <TimesheetSvg />,
  },
  {
    name: 'calendar-sync',
    description: gettext('Calendar app synchronization'),
    icon: <CalendarSyncSvg />,
  },
  {
    name: 'unavailability',
    description: gettext('Unavailability'),
    icon: <UnavailabilitySvg />,
  },
  {
    name: 'schedule-templates',
    description: gettext('Schedule templates'),
    icon: <ShiftSvg />,
  },
];
